'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren, useMemo } from 'react';

import { User } from '@/.gql/graphql';
import { GET_SUBSCRIPTIONS } from '@/.graphql';

import { createCustomContext } from './context';

interface ISubscriptionsProps {
  subscriptions: Array<User>;
}

const [SubscriptionsContext, useSubscriptionsContext] =
  createCustomContext<ISubscriptionsProps>({
    name: 'SubscriptionsContext',
    strict: false,
  });

export { useSubscriptionsContext };

interface Props extends PropsWithChildren {
  userId: string;
}

export const SubscriptionsProvider: FC<Props> = ({ children, userId }) => {
  const { data } = useSuspenseQuery(GET_SUBSCRIPTIONS, {
    variables: { userId },
  });

  const subscriptions = useMemo(() => data?.getSubscriptions ?? [], [data]);

  const contextValue = useMemo(() => ({ subscriptions }), [subscriptions]);

  return (
    <SubscriptionsContext value={contextValue}>{children}</SubscriptionsContext>
  );
};
